import { Button, FormControl, Grid, MenuItem } from "@mui/material";
import { useAppContext } from "AppContext";
import GKModal from "components/GKModal";
import GKSelect from "components/GKSelect";
import GKTextField from "components/GKTextField";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { IDENTIFIER, IDENTIFIER_STATUS } from "utils/constants";

const AddIdentifier = (props) => {
  const { isModalOpen, setIsModalOpen, refetch, identifierRowData } = props;
  const { id } = useParams();

  const {
    state: { currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      code_type: identifierRowData?.nbiId ? identifierRowData.codeType : "",
      code: identifierRowData?.nbiId ? identifierRowData.code : "",
      status: identifierRowData?.nbiId ? identifierRowData.status : "",
      series: identifierRowData?.nbiId ? identifierRowData.series : "",
    },
  });

  const onSubmit = async (values) => {
    try {
      if (identifierRowData?.nbiId) {
        await axiosInstance.put(
          `/admin-instrument-meta/${identifierRowData?.nbiId}/update/`,
          values
        );
      } else {
        await axiosInstance.post(`/admin-instrument-meta/${id}/create`, values);
      }
      refetch();
      setIsModalOpen(false);
    } catch (error) {}
  };

  const codeType = watch("code_type");

  return (
    <GKModal
      open={isModalOpen}
      setOpen={setIsModalOpen}
      modalTitle={
        identifierRowData?.nbiId ? "Update Identifier" : "Add New Identifier"
      }
      footer={
        <Grid container justifyContent={"flex-end"} gap={1}>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            onClick={() => setIsModalOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            type="submit"
            form="identifier-form"
            variant="outlined"
            disabled={isDisabled}
          >
            {identifierRowData?.nbiId ? "Update" : "Submit"}
          </Button>
        </Grid>
      }
    >
      <form id="identifier-form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <Controller
                  name="code_type"
                  control={control}
                  render={({ field }) => (
                    <GKSelect
                      className="col-span-6"
                      {...field}
                      inputLabel="Code Type"
                      displayEmpty
                      disabled={identifierRowData?.nbiId}
                    >
                      <MenuItem style={{ display: "none" }} value="">
                        Select Code Type
                      </MenuItem>
                      {IDENTIFIER?.map((dataItem, i) => (
                        <MenuItem key={i} value={dataItem.value}>
                          {dataItem.name}
                        </MenuItem>
                      ))}
                    </GKSelect>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <Controller
                  name="code"
                  control={control}
                  disabled={isDisabled}
                  render={({ field }) => (
                    <GKTextField
                      className="col-span-6"
                      {...field}
                      inputLabel="Code"
                      inputProps={{
                        maxLength: 24,
                        pattern:
                          codeType === "NSE" ? "^[A-Za-z0-9]+$" : "^[0-9]+$",
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <Controller
                  name="status"
                  control={control}
                  disabled={isDisabled}
                  render={({ field }) => (
                    <GKSelect
                      className="col-span-6"
                      {...field}
                      inputLabel="Status"
                      displayEmpty
                    >
                      <MenuItem style={{ display: "none" }} value="">
                        Select Status
                      </MenuItem>
                      {IDENTIFIER_STATUS?.map((dataItem, i) => (
                        <MenuItem key={i} value={dataItem.value}>
                          {dataItem.name}
                        </MenuItem>
                      ))}
                    </GKSelect>
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              {codeType === "NSE" && (
                <FormControl fullWidth variant="standard">
                  <Controller
                    name="series"
                    control={control}
                    disabled={isDisabled}
                    render={({ field }) => (
                      <GKTextField
                        className="col-span-6"
                        {...field}
                        inputLabel="Series"
                        inputProps={{
                          maxLength: 6,
                          pattern: "^[A-Za-z0-9]+$",
                        }}
                      />
                    )}
                  />
                </FormControl>
              )}
            </Grid>
          </Grid>
        </Grid>
      </form>
    </GKModal>
  );
};

export default AddIdentifier;
